import React, { useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import { setGlobalLoading } from 'redux/actions/actionCommon'
import AppFormikInputInline from 'utlis/helpers/forms/AppFormikInputInline'
import LoadingSkeleton from './LoadingSkeleton'

function OriginAddeess(props) {
    const { loading, formik } = props
    const [handleFee, setHandleFee] = useState(false)
    const [handleFeeCard, setHandleFeeCard] = useState(true)
    return (
        <>
            {handleFee && <Col lg={9} md={12} className="product-filter-right-content">
                {loading ? <LoadingSkeleton
                    height={450}
                /> :
                    <div className="app-card mb-3" >
                        <div className={`product-filter-card st-border-light`}>
                            <div className="card-content d-block">
                                <Col lg={8}>
                                    <div className="d-flex  flex-column">
                                        <div className="card-icon mb-2" >
                                            <div className="st-fs-16 st-fw-600 st-text-dark">Handing Fee</div>
                                        </div>
                                        <div className="">
                                            <Row className="pad-12-L">
                                                <Col lg={6} md={12} className="px-0">
                                                    <AppFormikInputInline
                                                        formik={formik}
                                                        stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"}
                                                        labelName={""}
                                                        isRequired={false}
                                                        placeholder={"Title"}
                                                        formikFieldName={"title"}
                                                    />
                                                </Col>
                                                <Col lg={6} md={12} className="px-0">
                                                    <AppFormikInputInline
                                                        formik={formik}
                                                        stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"}
                                                        labelName={""}
                                                        isRequired={false}
                                                        placeholder={"Fee, $"}
                                                        formikFieldName={"fee"}
                                                    />
                                                </Col>
                                                <Col lg={12} md={12} className="px-0">
                                                    {/* <AppFormikTextareaInline
                                                        formik={formik} // formik object
                                                        stFormClass={"st-form st-form-with-label-left d-flex flex-wrap"} // class name for main wrapper
                                                        labelName={"Meta Description"} // label name
                                                        placeholder={"Meta Description"} // placeholder for the input
                                                        textareaRows={"4"} // rows for textarea
                                                        formikFieldName={"metaDescription"} // important: formik value name for the input
                                                    /> */}
                                                </Col>
                                                <Col lg={6} md={12} className="px-0">
                                                    <div className="d-flex">
                                                        <button
                                                            type="submit"
                                                            className={`st-btn st-btn-primary d-flex align-items-center justify-content-center me-2`}
                                                        // disabled={editButtonDisable || Object.keys(formik.errors).length}
                                                        // onClick={handleFormSubmission}
                                                        >
                                                            {/* {
                                                            editButtonLoading ? (
                                                                <Spinner animation="border" size="sm" />
                                                            ) : ( */}
                                                            <span>Save</span>
                                                            {/* )
                                                        } */}
                                                        </button>
                                                        <button className="st-btn st-btn-gray d-flex align-items-center justify-content-center"
                                                            onClick={(e => {
                                                                setHandleFee(false)
                                                                setHandleFeeCard(true)
                                                            })}
                                                        >
                                                            Cancel
                                                        </button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </Col>
                            </div>
                        </div>
                    </div>}
            </Col >}
            {handleFeeCard &&
                <Col lg={9} md={12} className="product-filter-right-content">
                    {loading ? <LoadingSkeleton
                        height={140}
                    /> :
                        <div className="add-criteria">
                            <div className="product-filter-card">
                                <div className="card-content">
                                    <div className="card-text" style={{ width: "80%" }}>
                                        <div className="card-header_">
                                            <span>Handling Fee</span>
                                        </div>
                                        <div className="card-description">
                                            <div>
                                                This is a flat per-order charge that can be used to cover your expenses for packing and preparing an order. The handling fee is added to the order at checkout independently from the shipping cost. Keep your handling fees low to prevent cart abandonment.
                                            </div>
                                        </div>
                                    </div>
                                    <div className="" style={{ width: "20%" }}>
                                        <button
                                            style={{ width: "100%" }}
                                            type="submit"
                                            className="st-btn st-btn-primary st-btn-sm d-flex align-items-center text-capitalize mt-2 justify-content-center d-flex"
                                            onClick={(e => {
                                                setHandleFee(true)
                                                setHandleFeeCard(false)
                                            })}
                                        >
                                            <span>Set up Handling Fee</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>}
                </Col>
            }
        </>
    )
}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(OriginAddeess)